/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SectionHeading from "@components/sectionHeading";
import RequestedProductType from "@containers/PersonalLoan/components/requestedProductType";
import LoanSelect from "@containers/PersonalLoan/components/loanReason/loanReasons";
import TitleSelect from "@containers/PersonalLoan/components/namePrefix/namePrefix";
import MobileNoField from "@containers/PersonalLoan/components/mobilePhone/mobilePhone";
import FirstName from "@containers/PersonalLoan/components/firstName/firstName";
import LastName from "@containers/PersonalLoan/components/lastName/lastName";
import EmailField from "@containers/PersonalLoan/components/emailField/emailField";
import { DobField } from "@containers/PersonalLoan/components/dobField/dobField";
import ModalSaccWarning from "@containers/PersonalLoan/components/modals/saccWarningModal";
import { useFormikContext } from "formik";
import { isSaccLoan } from "@services/loanType";
import {
  useSetButtonText,
  useSetOnSubmit,
} from "../../context/formContext/submitButton";
import LoanAmountInput from "@containers/PersonalLoan/components/loanAmountInput/loanAmountInput";
import FieldWell from "@components/fieldWell";
import { PaperWidthRow } from "@components/paper/paper";
import { PaddingTopMobile } from "@components/padding";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";
import { FieldWellHeader } from "@components/sectionHeading/fieldWellHeader";
import LoanLimit from "@containers/PersonalLoan/components/loanLimit";
import { withAnimatedHeight } from "@components/animatedHeight";
import { YesLoansContent } from "@components/yesLoansAdditionalContent/yesLoansContent";
import ErrorModal from "@containers/PersonalLoan/components/errorModal/errorModal";
import actions from "@redux/loanForm/actions";
import { themes } from "@theme/config/theme.config";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";
import { FIELD_NAMES } from "@src/constants/commonConstants";
import { convertDomainToCorrespondingBrand } from "@utils/helpers/convertDomainToCorrespondingBrand";
import environmentSettings from "@src/constants/environmentSettings";
import ErrorWell from "@src/components/errorWell";
import styled from "styled-components";
import { size } from "styled-theme";

const AnimatedHeightCol = withAnimatedHeight(PaddingLeftCol);

const ErrorWellWrapper = styled.div`
  padding: 0;

  @media only screen and (min-width: ${size("S")}) {
      padding: 0 20px;
  }
`;

const StartForm = (props) => {
  const {
    values: { loanAmount, requestedProductType, title } = {},
    errors,
    touched,
    handleChange,
    handleBlur,
  } = props;

  const dispatch = useDispatch();

  const [saccModal, setSaccModal] = useState(false);
  const [saccModalNotAgreed, setSaccModalNotAgreed] = useState(true);
  const [errorModal, setErrorModal] = useState(false);

  const { isValid } = useFormikContext();
  const { isFetching } = useSelector((state) => state.loanForm);
  const { queryTheme, theme, loanReasonsError, queryString: { utm_campaign, utm_source, utm_medium, illionBrokerFlowDocumentId }, loanReasonsResponse } = useSelector((state) => state.StartUp);

  const { companyName } = environmentSettings;
  const brandName = convertDomainToCorrespondingBrand();

  usePendingPrefill(FIELD_NAMES.ILLION_BROKER_FLOW_DOCUMENT_ID);
  useSetDefaultValue(FIELD_NAMES.ILLION_BROKER_FLOW_DOCUMENT_ID, illionBrokerFlowDocumentId);
  useSetDefaultValue(FIELD_NAMES.BRAND, brandName);
  useSetDefaultValue(FIELD_NAMES.IS_LEAD, false);
  useSetDefaultValue(FIELD_NAMES.UTM_VALUES, { [FIELD_NAMES.UTM_CAMPAIGN]: utm_campaign, [FIELD_NAMES.UTM_SOURCE]: utm_source, [FIELD_NAMES.UTM_MEDIUM]: utm_medium, [FIELD_NAMES.THEME]: queryTheme });
  useSetDefaultValue(FIELD_NAMES.ALL_LOAN_TYPES, loanReasonsResponse);

  useEffect(() => {
    if (loanReasonsError) {
      setErrorModal(true);
    }
  }, [loanReasonsError]);
  
  useEffect(() => {
    dispatch(actions.setFieldInitialValue({[FIELD_NAMES.ALL_LOAN_TYPES]: loanReasonsResponse}));
  }, [loanReasonsResponse])

  const handleSubmit = () => {
    if (!isFetching) {
      const shouldShowSaccModal =
        isValid &&
        saccModalNotAgreed &&
        isSaccLoan(loanAmount * 1, requestedProductType);

      if (shouldShowSaccModal) {
        setSaccModal(true);
      } else {
        return true;
      }
    }

    return false;
  };
  useSetOnSubmit(handleSubmit);
  useSetButtonText("Go");

  const continueSubmit = () => {
    setSaccModal(false);
    setSaccModalNotAgreed(false);
    props.submitForm();
  };

  const restartFormHandler = () => {
    dispatch(actions.resetForm());
    window.location.reload(false);
  };

  return (
    <>
      <ModalSaccWarning
        visible={saccModal}
        close={() => setSaccModal(false)}
        continue={continueSubmit}
      />
      <ErrorModal visible={errorModal} restart={() => restartFormHandler()} />
      <PaperWidthRow>
        <PaddingLeftCol xl={12}>
          <FieldWellHeader hideMobile heading="About Your Loan" soft/>
        </PaddingLeftCol>
      </PaperWidthRow>
      <ErrorWellWrapper>
        <ErrorWell className="error-well-padding" errors={errors} touched={touched}/>
      </ErrorWellWrapper>
      <FieldWell>
        <PaddingTopMobile $padding="30" />
        <PaperWidthRow>
          <PaddingLeftCol xl={12}>
            <MarginLeftRow>
              <PaddingLeftCol xl={12}></PaddingLeftCol>
              <PaddingLeftCol sm={12} md={6}>
                <RequestedProductType />
              </PaddingLeftCol>
              <PaddingLeftCol sm={12} md={6}>
                <LoanSelect />
              </PaddingLeftCol>
            </MarginLeftRow>
            <MarginLeftRow>
              <AnimatedHeightCol initialHeight={83} sm={12} md={6}>
                {theme.themeName !== themes.fgfParent.yesLoans.themeName && <LoanLimit />}
              </AnimatedHeightCol>
              <PaddingLeftCol sm={12} md={6}>
                <LoanAmountInput />
              </PaddingLeftCol>
            </MarginLeftRow>
          </PaddingLeftCol>
        </PaperWidthRow>
      </FieldWell>
      <PaddingTopMobile $padding="18" />
      <PaperWidthRow>
        <PaddingLeftCol xl={12}>
          <SectionHeading heading="About you" asMobileHeader soft/>
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <TitleSelect
            onChange={handleChange}
            onBlur={handleBlur}
            value={title}
            name="title"
            errorMessage={touched.title ? errors.title : ""}
          />
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <FirstName />
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow>
        <PaddingLeftCol sm={12} md={6}>
          <LastName />
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <DobField />
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow>
        <PaddingLeftCol sm={12} md={6}>
          <MobileNoField />
        </PaddingLeftCol>
        <PaddingLeftCol sm={12} md={6}>
          <EmailField />
        </PaddingLeftCol>
      </PaperWidthRow>
      <PaperWidthRow>
        {theme.themeName === themes.fgfParent.yesLoans.themeName && (
          <YesLoansContent>
            <p>
              Yes Loans will receive a commission from {companyName}, at no
              cost to you, if you proceed to enter into a credit contract.
            </p>
          </YesLoansContent>
        )}
      </PaperWidthRow>
    </>
  );
};

export default StartForm;
